/**
 * Os tamanhos-padrão do logo e dos botões da Home — o valor que vale quando a
 * configuração do PDV não traz nada.
 *
 * Estavam repetidos em três arquivos (`subsidiarySlice.ts`,
 * `pdvConfig.service.ts` e `state.service.ts`), o que fazia `grep "420px" src/`
 * devolver seis lugares diferentes para o mesmo conceito. Agora é um só.
 *
 * ATENÇÃO — são DUAS situações, com valores DIFERENTES de propósito:
 *
 *   - ESTADO INICIAL: a loja ainda não escolheu PDV nenhum. Logo de 300px.
 *   - REGISTRO VAZIO: o PDV existe e o campo veio em branco. Logo de 100px.
 *
 * Não unificar num valor só. Enquanto o logo saía em `width: NaN%` (descartado)
 * os dois davam no mesmo tamanho natural e a diferença não aparecia; agora que
 * a string é respeitada (ver `dimensaoDaConfig.ts`), unificar mudaria o tamanho
 * do logo numa das duas situações sem ninguém ter pedido.
 *
 * A forma é string em px porque é assim que o valor está gravado hoje e é assim
 * que o slider de Main.modal.tsx grava. Quem traduz para CSS é
 * `dimensaoDaConfig.ts` — aqui só mora o número.
 */

/** Estado inicial da loja, antes de qualquer PDV escolhido. */
export const PADRAO_LOGO_ESTADO_INICIAL = "300px";
export const PADRAO_BOTAO_ESTADO_INICIAL = "420px";

/** Registro do PDV com o campo vazio. */
export const PADRAO_LOGO_REGISTRO_VAZIO = "100px";
export const PADRAO_BOTAO_REGISTRO_VAZIO = "420px";
